import { useEffect, useRef, useState } from 'react';
import {
    getPayrollDayWarningExpense,
    getPayrollDayWarningMessage,
    shouldShowPayrollDayApprovalWarning,
} from '../Utils/payrollDayWarning';

const usePayrollDayApprovalWarning = ({ creditMemoDialogOpen } = {}) => {
    const [payrollWarningOpen, setPayrollWarningOpen] = useState(false);
    const [showPayrollWarningInCmm, setShowPayrollWarningInCmm] = useState(false);
    const [payrollWarningMessage, setPayrollWarningMessage] = useState('');
    const pendingProceedRef = useRef(null);
    const cmmWarningAcknowledgedRef = useRef(false);

    useEffect(() => {
        if (creditMemoDialogOpen) return;

        setShowPayrollWarningInCmm(false);
        cmmWarningAcknowledgedRef.current = false;
    }, [creditMemoDialogOpen]);

    const gateApproval = ({
        expenses,
        originalExpenses,
        isCreditMemoFlow = false,
        proceed,
    } = {}) => {
        const shouldWarn = shouldShowPayrollDayApprovalWarning({
            expenses,
            originalExpenses,
            isCreditMemoFlow,
        });

        if (!shouldWarn || (isCreditMemoFlow && cmmWarningAcknowledgedRef.current)) {
            proceed?.();
            return false;
        }

        const warningExpense = getPayrollDayWarningExpense(
            expenses,
            originalExpenses,
            isCreditMemoFlow
        );
        setPayrollWarningMessage(getPayrollDayWarningMessage(warningExpense));

        if (isCreditMemoFlow) {
            cmmWarningAcknowledgedRef.current = true;
            setShowPayrollWarningInCmm(true);
            return true;
        }

        pendingProceedRef.current = proceed;
        setPayrollWarningOpen(true);
        return true;
    };

    const confirmPayrollWarning = () => {
        const proceed = pendingProceedRef.current;
        pendingProceedRef.current = null;
        setPayrollWarningOpen(false);
        proceed?.();
    };

    const cancelPayrollWarning = () => {
        pendingProceedRef.current = null;
        setPayrollWarningOpen(false);
    };

    return {
        payrollWarningOpen,
        showPayrollWarningInCmm,
        payrollWarningMessage,
        gateApproval,
        confirmPayrollWarning,
        cancelPayrollWarning,
    };
};

export default usePayrollDayApprovalWarning;
